import { useEffect, useState } from "react";
import { useI18n, type StringKey } from "../i18n";
import { loadReminders, type Reminder } from "../data";
import type { Workspace } from "../types";

const tone: Record<Reminder["kind"], string> = {
  policy_ack: "warning", document_expiring: "warning", document_expired: "danger", leave_approved: "success",
  leave_rejected: "danger", letter_ready: "success", letter_declined: "danger", profile_approved: "success",
  profile_rejected: "danger", probation_end: "info",
};
const target: Partial<Record<Reminder["kind"], string>> = {
  policy_ack: "policies", leave_approved: "myleave", leave_rejected: "myleave", letter_ready: "myletters",
  letter_declined: "myletters", profile_approved: "myrequests", profile_rejected: "myrequests",
};

/** "For you": the signed-in person's own reminders (needs Alerts and a linked employee record). */
export function Reminders({ ws, onGo, empty }: { ws: Workspace; onGo: (page: string) => void; empty?: boolean }) {
  const { t, pick } = useI18n();
  const [rows, setRows] = useState<Reminder[] | null>(null);
  useEffect(() => {
    if (!ws.enabled.has("alerts") || !ws.membership.employment_id) { setRows([]); return; }
    loadReminders(ws.membership.company_id).then(setRows).catch(() => setRows([]));
  }, [ws.membership.company_id, ws.membership.employment_id, ws.enabled]);
  if (rows === null || (rows.length === 0 && !empty)) return null;
  return (
    <section className="card">
      <h2>{t("forYou")}</h2>
      {rows.length === 0 ? <p className="muted">{t("nothingForYou")}</p> : (
        <ul className="alert-list">
          {rows.map((r) => {
            const go = target[r.kind];
            const title = r.title_en ? pick(r.title_en, r.title_ar) : "";
            return (
              <li key={`${r.kind}-${r.ref_id}`}>
                <span className={`badge ${tone[r.kind]}`}>{t(`rem_${r.kind}` as StringKey)}</span>
                {go ? <button type="button" className="link" onClick={() => onGo(go)}>{title || t(`remGo_${go}` as StringKey)}</button> : <span>{title}</span>}
                {r.detail && <span className="muted">{r.kind === "letter_ready" ? r.detail : `“${r.detail}”`}</span>}
                {r.due_date && <span className="mono muted alert-when">{r.due_date}</span>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
